var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.toBeImportedUsersCounterSection},[_c('h6',{class:_vm.$style.topTitle},[_vm._v(" To be imported ")]),_c('span',{class:_vm.$style.toBeImportedUsers},[_vm._v(_vm._s(_vm.selectedItemsCount))]),_c('span',{class:_vm.$style.toBeImportedUsersLabel},[_vm._v("users")])])
}
var staticRenderFns = []

export { render, staticRenderFns }